<template>
  <div class="form-group c-input-inline-text">
    <label v-if="label" class="form__label" :for="slug">{{ label }}</label>

    <span
      v-if="!editing"
      @dblclick="enableEditing"
      class="c-input-inline-text__display"
    >
      {{ text || placeholder }}
    </span>

    <input
      v-else
      :id="slug"
      type="text"
      v-model="text"
      :placeholder="placeholder"
      :class="[{ 'form-control': noStyle === false }]"
      @blur="save"
      @keyup.enter="save"
      ref="input"
    />

    <InputError v-if="hasError" :message="errorMessage" />
    <InputDescription v-if="description" :message="description" />
  </div>
</template>

<script>
import InputError from './input-error';
import InputDescription from './input-description';
import slugify from '@swipekit/lib/slugify.js';

export default {
  components: {
    InputError,
    InputDescription,
  },

  props: {
    label: {
      type: String,
      default: '',
    },
    validation: {},
    value: {},
    placeholder: {
      type: String,
      default: '',
    },
    noStyle: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {},
  },

  data() {
    return {
      text: '',
      editing: false,
    };
  },

  computed: {
    slug() {
      return slugify(this.label || `input_${Math.floor(Math.random() * 100)}`);
    },
  },

  watch: {
    value(newVal) {
      if (newVal !== this.text) {
        this.text = newVal;
      }
    },
  },

  methods: {
    enableEditing() {
      this.editing = true;
      this.$nextTick(() => {
        this.$refs.input && this.$refs.input.focus();
      });
    },
    save() {
      this.editing = false;
      this.$emit('input', this.text);
    },
  },

  mounted() {
    this.text = this.value || '';
  },
};
</script>

<style lang="scss">
.c-input-inline-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &__display {
    // cursor: pointer;
    // padding: 4px 8px;
    // min-height: 36px;
    // line-height: 1.4;
    // border: 1px solid transparent;

    // &:hover {
    //  border: 1px solid #ccc;
    //  border-radius: 4px;
    // }
  }

  .form-control {
    padding: 0 var(--margin);
    min-height: 24.2px;
    font-size: var(--font-size-sm);
    line-height: 1;
  }
}
</style>
